/**
 * @description
 */

import { fetchData } from '@umu/umu-fetch';

import Api from '../../../../path';

export interface IInput {
    practice_id: number;
    question_ids: string; // number[].join(',');
}

export type IOutput = IServerQuizAnswerMap;

export const getQuestionAnswer = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_GET_QUESTION_ANSWER, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
